import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import {tap} from 'rxjs/operators'
import { Observable,of } from 'rxjs';
import { Constants } from 'src/app/core/constants/url.constants';
import { environment } from 'src/environments/environment';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Router } from '@angular/router';
@Injectable({providedIn:'root'})
export class CommonInterceptorInterceptors implements HttpInterceptor {
  private cache = new Map<string, HttpResponse<any>>();
  
  private endpointsUrl = new Set([ ]);
  userid: string;
  constructor(  private userAccountFacade: UserAccountFacade
    , private router:Router
    ) {
    this.userAccountFacade.get().subscribe(data => {
      if (data) {
        this.userid = data.uid;
        console.log(this.userid);
      }
    });
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const url = request.url.replace(environment.baseUrl,'');
    // const landingPage = localStorage.getItem('defaultLandingPage');
    // if(this.router?.routerState?.snapshot?.url==''){
    //   console.log(33);
    //   if(landingPage){
    //     console.log('defined');
    //     console.log("/"+landingPage);
    //     this.router.navigate([landingPage]);
    //   }
    // }
    let usergroup = localStorage.getItem('groupCompany');
    this.endpointsUrl.add(Constants.profileData(this.userid).BHPUNITLIST);
    this.endpointsUrl.add(Constants.getASMAccess());
    //this.endpointsUrl.add(Constants.getgroupuser(this.userid,usergroup).MASTERDATA);
    if(this.endpointsUrl.has(url)){
      const cachedResponse = this.cache.get(request.url);
      if(cachedResponse){
        return of (cachedResponse);
      }
      return next.handle(request).pipe(
        tap((response)=>{
          if(response instanceof HttpResponse){
            this.cache.set(request.url,response);
          }
        })
      )
    }
    return next.handle(request);
  }
}
